import { render, staticRenderFns } from "./MyCocoCoinItem.vue?vue&type=template&id=86748a2e&scoped=true&"
import script from "./MyCocoCoinItem.vue?vue&type=script&lang=js&"
export * from "./MyCocoCoinItem.vue?vue&type=script&lang=js&"
import style0 from "./MyCocoCoinItem.vue?vue&type=style&index=0&id=86748a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86748a2e",
  null
  
)

export default component.exports